import { defineStore } from 'pinia';
import {useDictionaryStore} from './dictionary';
export const useSettingsStore = defineStore('settings', {
  state: () => ({
    language: 'ru',
    country: null,
    currency: null,
  }),
  actions: {
    init() {
      // const dictionaryStore = useDictionaryStore();
      // const currentCountry = localStorage.getItem('country');
      // const currentCountryObject = dictionaryStore.dictionary.countries?.find((country) => country.code === currentCountry);
      // if (currentCountry && currentCountryObject) {
      //   this.country = currentCountry;
      //   this.currency = dictionaryStore.dictionary?.currencies?.find(currency => currency.id === currentCountryObject.currency_id);
      // } else {
      //   this.country = dictionaryStore.dictionary.countries?.[0].code;
      //   localStorage.setItem('country', dictionaryStore.dictionary.countries?.[0].code);
      //   this.currency = dictionaryStore.dictionary?.currencies?.find(currency => currency.id === dictionaryStore.dictionary.countries?.[0].currency_id);
      // }
    }
  }
});
